<template>
  <div
    class="relative flex flex-col w-full h-full bg-EXPONDO-secondary-light
          rounded-lg overflow-hidden border"
  >
    <a
      :href="bannerButtonLink"
      class="absolute z-10 left-0 top-0 w-full h-full"
      :aria-label="bannerHeader"
    />
    <ImgView
      :src="bannerImage"
      img-classes="mx-auto h-4/6 object-cover w-full"
      :alt="bannerHeader"
    />
    <div class="p-4 mx-auto flex flex-col w-full gap-2.5 h-2/6">
      <h2 class="font-bold text-2xl">
        {{ bannerHeader }}
      </h2>
      <p>{{ bannerDescription }}</p>
      <CustomButton
        type="secondary"
        :text="bannerButtonText"
        class="mt-auto"
      />
    </div>
  </div>
</template>

<script lang="ts">


export default defineComponent({
  name: 'ProductSliderBanner',

  props: {
    bannerHeader: {
      type: String,
      required: true,
    },
    bannerDescription: {
      type: String,
      required: true,
    },
    bannerButtonText: {
      type: String,
      required: true,
    },
    bannerButtonLink: {
      type: String,
      required: true,
    },
    bannerImage: {
      type: String,
      required: true,
    },
  },
});

</script>
